export const DEFAULT_CATEGORY_ICON_PADDING = '8px';
export const DEFAULT_CATEGORY_ICON_COLOR = '#6B7280';
export function isDefaultCategoryIconColor(color) {
    if (!color?.trim())
        return true;
    return color.trim().toLowerCase() === DEFAULT_CATEGORY_ICON_COLOR.toLowerCase();
}
/** Icon-Farbe je Kontext: Standard-Grau auf dunklem Header wäre unsichtbar. */
export function resolveCategoryIconDisplayColor(categoryColor, context, accentColor) {
    const custom = categoryColor?.trim();
    const hasCustom = Boolean(custom && !isDefaultCategoryIconColor(custom));
    if (context === 'onDark') {
        return hasCustom ? custom : undefined;
    }
    if (context === 'active') {
        return hasCustom ? custom : accentColor;
    }
    return hasCustom ? custom : undefined;
}
export function normalizeCategoryIconSizeValue(input, fallback) {
    const value = Number(input?.value);
    const unit = input?.unit === 'rem' ? 'rem' : 'px';
    if (!Number.isFinite(value) || value < 0)
        return fallback;
    return { value, unit };
}
export function categoryIconSizeToCss(entry) {
    return `${entry.value}${entry.unit}`;
}
export function resolveCategoryIconPadding(input, fallback = DEFAULT_CATEGORY_ICON_PADDING) {
    if (typeof input === 'string') {
        const trimmed = input.trim();
        return trimmed || fallback;
    }
    if (input && typeof input === 'object') {
        const value = Number(input.value);
        const unit = input.unit === 'rem' ? 'rem' : 'px';
        if (Number.isFinite(value))
            return `${value}${unit}`;
    }
    return fallback;
}
